// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    cursor: inherit;
    box-sizing: border-box;
}

:after, :before {
    box-sizing: border-box;
}

html, body {
    overflow: hidden;
    cursor: default;
    color: var(--text-color);
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
    margin: 0;
    padding: 0;
}

html, body, #container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

a {
    cursor: pointer;
    color: var(--text-color-link);
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

h1, h2, h3, h4 {
    font-weight: 500;
    margin: 0.5em 0;
}

h1 { font-size: 160%; }
h2 { font-size: 150%; }
h3 { font-size: 140%; }
h4 { font-size: 130%; }
h5 { font-size: 120%; }
h6 { font-size: 110%; }

table {
    border-collapse: collapse;
    font-size: 14px;
}

ul {
    margin: 0;
}

input, select, button, textarea {
    border-radius: 0;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    margin: 0;
}

input:focus, select:focus, button:focus, textarea:focus {
    outline: var(--focus-outline);
}

textarea, input:not([type=checkbox]):not([type=radio]):not([type=range]), select {
    padding: 0.25em;
    border: 1px solid var(--border-color);
    background-color: var(--input-bg-color);
    color: var(--text-color);
}

input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=file]), select {
    height: 2em;
    border-radius: var(--border-radius);
}

textarea, input:not([type=checkbox]):not([type=radio]):not([type=range]) {
    cursor: text;
}

input:read-only, textarea:read-only, input:not([type=checkbox]):not([type=radio]):not([type=range]):read-only {
    color: var(--text-color-disabled);
}

input:disabled, select:disabled, textarea:disabled {
    background-color: var(--input-bg-color-disabled);
    color: var(--text-color-disabled);
}

input:invalid, select:invalid, textarea:invalid, input:not([type=checkbox]):not([type=radio]):not([type=range]):invalid {
    background-color: #FFAAAA;
}

/** Button **/
button.button {
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    border: 1px solid var(--border-color);
    display: inline-flex;
    padding: 0.5em;
    align-items: center;
    justify-content: center;
    height: 2em;
    overflow: hidden;
    cursor: pointer;
    outline: none;
}

button.button:focus {
    outline: var(--focus-outline);
}

button.button:disabled {
    background-color: var(--button-bg-color-disabled);
    color: var(--button-text-color-disabled);
    cursor: default;
}

button.button:not(:disabled):hover {
    background-color: var(--button-bg-color-hover);
    color: var(--button-text-color-hover);
}

button.button.pressed:not(:disabled):hover {
    background-color: var(--button-bg-color-active-hover);
    color: var(--button-text-color-active-hover);
}

button.button.pressed:not(:disabled) {
    background-color: var(--button-bg-color-active);
    color: var(--button-text-color-active);
}

button.button-accept {
    background-color: rgb(127,255,127);
}

button.button-warning {
    background-color: #ffd979;
}

button.button-reject {
    background-color: rgb(255,127,127);
}

button.button-accept:not(:disabled):hover {
    background-color: rgb(127,225,127);
}

button.button-reject:not(:disabled):hover {
    background-color: rgb(225,127,127);
}

button.button > * {
    flex: 0 0 auto;
}

button.button:not(:disabled):active > * {
    transform: translateX(1px) translateY(1px);
}

button.button > span:not(.icon) {
    margin: 0 0.25em;
}

button.button > div.spinner {
    width: 1.5em;
    height: 1.5em;
}

button.selected {
    position: relative;
}
button.selected:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    background-color: var(--color-active);
    border-top: 1px solid var(--border-color);
    content: "";
}

div.controlgroup {
    display: flex;
    align-items: center;
}

div.controlgroup > .controlgroup-fillitem {
    flex: 1 1 auto;
    width: 0;
}

div.controlgroup > .controlgroup-expanditem {
    flex: 1 0 auto;
}

div.controlgroup > *:not(:last-child):not(span) {
    margin-right: -1px;
}

/** Range slider **/
input[type=range] {
    -webkit-appearance: none;
    appearance: none;
    background-color: transparent;
    height: 2em;
}

input[type=range]::-moz-range-track {
    background: #ddd;
    height: 4px;
}

input[type=range]::-webkit-slider-runnable-track {
    background: #ddd;
    height: 4px;
}

input[type=range]::-moz-range-thumb {
    appearance: none;
    -webkit-appearance: none;
    border: 1px solid var(--border-color);
    border-radius: 50%;
    height: 12px;
    width: 12px;
    box-sizing: border-box;
    background: var(--input-bg-color);
    margin-top: -3.5px;
}

input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: 1px solid var(--border-color);
    border-radius: 50%;
    height: 12px;
    width: 12px;
    box-sizing: border-box;
    background: var(--input-bg-color);
    margin-top: -3.5px;
}

div.__event_shield {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999999999999;
}`, "",{"version":3,"sources":["webpack://./components/style/App.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,wDAAwD;IACxD,eAAe;IACf,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,KAAK,eAAe,EAAE;AACtB,KAAK,eAAe,EAAE;AACtB,KAAK,eAAe,EAAE;AACtB,KAAK,eAAe,EAAE;AACtB,KAAK,eAAe,EAAE;AACtB,KAAK,eAAe,EAAE;;AAEtB;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,uCAAuC;IACvC,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gDAAgD;IAChD,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,aAAa;AACb;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,qCAAqC;IACrC,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,qDAAqD;IACrD,4CAA4C;AAChD;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,qCAAqC;IACrC,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,wBAAwB;IACxB,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,qBAAqB;AACzB","sourcesContent":["* {\n    cursor: inherit;\n    box-sizing: border-box;\n}\n\n:after, :before {\n    box-sizing: border-box;\n}\n\nhtml, body {\n    overflow: hidden;\n    cursor: default;\n    color: var(--text-color);\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-size: 14px;\n    margin: 0;\n    padding: 0;\n}\n\nhtml, body, #container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\na {\n    cursor: pointer;\n    color: var(--text-color-link);\n    text-decoration: none;\n}\n\na:hover {\n    text-decoration: underline;\n}\n\nh1, h2, h3, h4 {\n    font-weight: 500;\n    margin: 0.5em 0;\n}\n\nh1 { font-size: 160%; }\nh2 { font-size: 150%; }\nh3 { font-size: 140%; }\nh4 { font-size: 130%; }\nh5 { font-size: 120%; }\nh6 { font-size: 110%; }\n\ntable {\n    border-collapse: collapse;\n    font-size: 14px;\n}\n\nul {\n    margin: 0;\n}\n\ninput, select, button, textarea {\n    border-radius: 0;\n    color: inherit;\n    font-family: inherit;\n    font-size: inherit;\n    margin: 0;\n}\n\ninput:focus, select:focus, button:focus, textarea:focus {\n    outline: var(--focus-outline);\n}\n\ntextarea, input:not([type=checkbox]):not([type=radio]):not([type=range]), select {\n    padding: 0.25em;\n    border: 1px solid var(--border-color);\n    background-color: var(--input-bg-color);\n    color: var(--text-color);\n}\n\ninput:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=file]), select {\n    height: 2em;\n    border-radius: var(--border-radius);\n}\n\ntextarea, input:not([type=checkbox]):not([type=radio]):not([type=range]) {\n    cursor: text;\n}\n\ninput:read-only, textarea:read-only, input:not([type=checkbox]):not([type=radio]):not([type=range]):read-only {\n    color: var(--text-color-disabled);\n}\n\ninput:disabled, select:disabled, textarea:disabled {\n    background-color: var(--input-bg-color-disabled);\n    color: var(--text-color-disabled);\n}\n\ninput:invalid, select:invalid, textarea:invalid, input:not([type=checkbox]):not([type=radio]):not([type=range]):invalid {\n    background-color: #FFAAAA;\n}\n\n/** Button **/\nbutton.button {\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    border: 1px solid var(--border-color);\n    display: inline-flex;\n    padding: 0.5em;\n    align-items: center;\n    justify-content: center;\n    height: 2em;\n    overflow: hidden;\n    cursor: pointer;\n    outline: none;\n}\n\nbutton.button:focus {\n    outline: var(--focus-outline);\n}\n\nbutton.button:disabled {\n    background-color: var(--button-bg-color-disabled);\n    color: var(--button-text-color-disabled);\n    cursor: default;\n}\n\nbutton.button:not(:disabled):hover {\n    background-color: var(--button-bg-color-hover);\n    color: var(--button-text-color-hover);\n}\n\nbutton.button.pressed:not(:disabled):hover {\n    background-color: var(--button-bg-color-active-hover);\n    color: var(--button-text-color-active-hover);\n}\n\nbutton.button.pressed:not(:disabled) {\n    background-color: var(--button-bg-color-active);\n    color: var(--button-text-color-active);\n}\n\nbutton.button-accept {\n    background-color: rgb(127,255,127);\n}\n\nbutton.button-warning {\n    background-color: #ffd979;\n}\n\nbutton.button-reject {\n    background-color: rgb(255,127,127);\n}\n\nbutton.button-accept:not(:disabled):hover {\n    background-color: rgb(127,225,127);\n}\n\nbutton.button-reject:not(:disabled):hover {\n    background-color: rgb(225,127,127);\n}\n\nbutton.button > * {\n    flex: 0 0 auto;\n}\n\nbutton.button:not(:disabled):active > * {\n    transform: translateX(1px) translateY(1px);\n}\n\nbutton.button > span:not(.icon) {\n    margin: 0 0.25em;\n}\n\nbutton.button > div.spinner {\n    width: 1.5em;\n    height: 1.5em;\n}\n\nbutton.selected {\n    position: relative;\n}\nbutton.selected:after {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 3px;\n    background-color: var(--color-active);\n    border-top: 1px solid var(--border-color);\n    content: \"\";\n}\n\ndiv.controlgroup {\n    display: flex;\n    align-items: center;\n}\n\ndiv.controlgroup > .controlgroup-fillitem {\n    flex: 1 1 auto;\n    width: 0;\n}\n\ndiv.controlgroup > .controlgroup-expanditem {\n    flex: 1 0 auto;\n}\n\ndiv.controlgroup > *:not(:last-child):not(span) {\n    margin-right: -1px;\n}\n\n/** Range slider **/\ninput[type=range] {\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: transparent;\n    height: 2em;\n}\n\ninput[type=range]::-moz-range-track {\n    background: #ddd;\n    height: 4px;\n}\n\ninput[type=range]::-webkit-slider-runnable-track {\n    background: #ddd;\n    height: 4px;\n}\n\ninput[type=range]::-moz-range-thumb {\n    appearance: none;\n    -webkit-appearance: none;\n    border: 1px solid var(--border-color);\n    border-radius: 50%;\n    height: 12px;\n    width: 12px;\n    box-sizing: border-box;\n    background: var(--input-bg-color);\n    margin-top: -3.5px;\n}\n\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    border: 1px solid var(--border-color);\n    border-radius: 50%;\n    height: 12px;\n    width: 12px;\n    box-sizing: border-box;\n    background: var(--input-bg-color);\n    margin-top: -3.5px;\n}\n\ndiv.__event_shield {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 999999999999;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
